import { REVENUE_API_PATH } from 'constants/api';
import { ApiService } from 'service/api/apiService';
import { FetchResult } from 'type/apiType';
import { RevenueInterface } from '../types/revenueDashboardType';

class RevenueDashboardService {
  constructor(private readonly apiService: ApiService<RevenueInterface>) {}

  public async fetch(queryParams?: URLSearchParams): Promise<FetchResult<RevenueInterface>> {
    return await this.apiService.fetch(queryParams);
  }

  public async fetchAll(queryParams?: URLSearchParams): Promise<RevenueInterface[]> {
    let startPage = 1;
    let hasNext = true;
    const { results, page_next: nextPage } = await this.apiService.fetch(
      new URLSearchParams(queryParams)
    );
    const mergedData: RevenueInterface[] = results;
    hasNext = nextPage !== null;
    while (hasNext) {
      ++startPage;
      queryParams?.set('page', startPage.toString());
      const { results, page_next: nextPage } = await this.apiService.fetch(
        new URLSearchParams(queryParams)
      );
      hasNext = nextPage !== null;
      mergedData.push(...results);
    }

    return mergedData;
  }
}

export const revenueDashboardService = new RevenueDashboardService(
  new ApiService(REVENUE_API_PATH)
);
